export const LOCKED_POST_IMAGES = {
  PREVIEW_DEFAULT: "https://i.postimg.cc/4xH1JCs0/image-17.png",
  DOCUMENT_PLACEHOLDER: "https://i.postimg.cc/LX2SKYJ6/image-20.png",
  POLL_PLACEHOLDER: "https://i.postimg.cc/k5w1GBj5/image-21.png",
};
